import * as React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from 'containers/Home'
import Search from 'containers/Search'
import ExploreDetail from 'containers/ExploreDetail'
import Campaign from 'containers/Campaign'
import CampaignUpdate from 'containers/CampaignUpdate'
import Explore from 'containers/Explore'
import Contribute from 'containers/Contribute'
import Donations from 'containers/Donations'
import ZakatContainer from 'containers/ZakatContainer'
import { FailedPage } from '@3pp/ui-library'

import 'styles/main.scss'

const App = () => {
  let isKbplus: boolean
  return (
    <Router>
      <Switch>
        <Route path="/" exact render={(props) => (
          <Home {...props} />
        )} />
        <Route path="/search" render={(props) => (
          <Search {...props} />
        )} />
        <Route path="/explore/" exact render={(props) => (
          <Explore {...props} />
        )} />
        <Route path="/explore/:slug" render={(props) => (
          <ExploreDetail {...props} />
        )} />
        <Route path="/campaign/:slug" exact render={(props) => {
          isKbplus = props.match.params.slug === 'plus'
          return (
            isKbplus
              ? window.location.href = `${process.env.REACT_APP_KBPLUS_URL}?utm_source=3pp_dana`
              : <Campaign {...props} />
          )}} />
        <Route path="/campaign/:slug/:id/latest-news" exact render={(props) => (
          <CampaignUpdate {...props} />
        )} />
        <Route path="/campaign/:shortUrl/contribute" exact render={(props) => (
          <Contribute {...props} />
        )} />
        <Route path="/donations/:slug" exact render={(props) => (
          <Donations {...props} />
        )} />
        <Route path="/zakat-calculator" render={(props) => (
          <ZakatContainer {...props} />
        )} />
        <Route render={(props) => (
          <FailedPage 
            title="Halaman tidak ditemukan" 
            information="Saat ini kamu belum bisa mengakses halaman ini, kamu bisa kembali lagi nanti."
            from="/"
          />
        )} />
      </Switch>
    </Router>
  );
};

export default App;
